import { Calendar, CheckSquare } from "lucide-react";
import { Avatar, PRIORITIES, dueState } from "../lib/helpers";

const DUE_CLS = { overdue: "text-red-400", soon: "text-amber-400" };

export const ListView = ({ board, tasks, users, onOpen }) => (
  <div className="p-4 sm:p-6 lg:p-8 space-y-6 overflow-y-auto h-full" data-testid="list-view">
    {board.columns.map((col, ci) => {
      const rows = tasks.filter((t) => t.status === col.id).sort((a, b) => a.order - b.order);
      return (
        <div key={col.id} className="animate-fade-up" style={{ animationDelay: `${ci * 80}ms` }}>
          <div className="flex items-center gap-2 mb-2">
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: col.color }} />
            <h3 className="font-semibold text-sm">{col.title}</h3>
            <span className="text-xs text-zinc-500 bg-white/5 rounded-full px-2 py-0.5">{rows.length}</span>
          </div>
          <div className="bg-[#0E0E10] border border-white/5 rounded-xl overflow-hidden divide-y divide-white/5">
            {rows.length === 0 && <p className="text-sm text-zinc-600 px-4 py-3">Sin tareas</p>}
            {rows.map((t, ri) => {
              const pr = PRIORITIES[t.priority] || PRIORITIES.medium;
              const ds = dueState(t.due_date);
              const assignees = (t.assignee_ids || []).map((id) => users.find((u) => u.id === id)).filter(Boolean);
              const subs = t.subtasks || [];
              return (
                <div key={t.id} onClick={() => onOpen(t)} data-testid={`list-row-${t.id}`}
                  style={{ animationDelay: `${Math.min(ri * 35, 400)}ms` }}
                  className="grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_100px_90px_110px_80px] items-center gap-3 px-4 py-2.5 hover:bg-white/5 cursor-pointer transition-colors animate-fade-up">
                  <div className="min-w-0">
                    <p className="text-sm font-medium truncate">{t.title}</p>
                    {col.title.toLowerCase().includes("progreso") && (
                      <div className="flex items-center gap-2 mt-1" data-testid={`progress-bar-${t.id}`}>
                        <div className="h-1 w-24 bg-white/5 rounded-full overflow-hidden"><div className="h-full bg-[#FFD600] rounded-full" style={{ width: `${t.progress || 0}%` }} /></div>
                        <span className="text-[10px] font-semibold text-[#FFD600]">{t.progress || 0}%</span>
                      </div>
                    )}
                  </div>
                  <div className="hidden sm:flex -space-x-2">
                    {assignees.slice(0, 3).map((u) => <Avatar key={u.id} user={u} size={24} className="ring-2 ring-[#0E0E10]" />)}
                  </div>
                  <span className="hidden sm:flex items-center gap-1.5 text-xs" style={{ color: pr.color }}>
                    <span className="h-1.5 w-1.5 rounded-full" style={{ background: pr.color }} />{pr.label}
                  </span>
                  <span className={`flex items-center gap-1 text-xs ${DUE_CLS[ds] || "text-zinc-500"}`}>
                    {t.due_date ? (<><Calendar className="h-3.5 w-3.5" />{new Date(t.due_date).toLocaleDateString("es", { day: "numeric", month: "short" })}{ds === "overdue" && " · vencida"}</>) : "—"}
                  </span>
                  <span className="hidden sm:flex items-center gap-1 text-xs text-zinc-500">
                    {subs.length > 0 && (<><CheckSquare className="h-3.5 w-3.5" />{subs.filter((s) => s.done).length}/{subs.length}</>)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      );
    })}
  </div>
);
